module.exports = __webpack_public_path__ + "img/guinea-bissau.6a5a27ff.png";